import { toast } from 'sonner';

// S135 — abrir un papel que arma el servidor.
//
// Las cinco verticales sacan papel de la misma forma: el servidor devuelve el
// documento ya armado en HTML y el navegador de quien está ahí lo manda a su
// impresora. Se hace así —y no generando un PDF en el servidor— porque la
// impresora suele estar colgada por USB de la computadora del mostrador, y un
// servidor en la nube no puede verla.
//
// El bloqueo de ventanas emergentes es el fallo más común de este camino y no
// avisa solo: el usuario aprieta «Imprimir», no pasa nada y cree que la app
// está rota. Por eso se detecta y se dice qué hacer.

export function abrirParaImprimir(html, { titulo = 'Documento' } = {}) {
  if (!html) {
    toast.error('El documento vino vacío. Vuelve a intentarlo.');
    return false;
  }
  const ventana = window.open('', '_blank', 'width=820,height=900');
  if (!ventana) {
    toast.error(
      'Tu navegador bloqueó la ventana de impresión. Permite las ventanas '
      + 'emergentes de este sitio y vuelve a intentarlo.',
      { duration: 8000 },
    );
    return false;
  }
  ventana.document.write(html);
  ventana.document.close();
  try { ventana.document.title = titulo; } catch { /* da igual si no deja */ }
  return true;
}

// Para los papeles que el servidor intenta mandar a una impresora de red y,
// si falla, devuelve el respaldo. Traduce el resultado a lo que la persona
// necesita saber, sin jerga.
export function avisarImpresion(resultado, { queEs = 'El documento' } = {}) {
  if (!resultado) return;
  if (resultado.ok && resultado.via === 'red') {
    toast.success(`${queEs} salió en la impresora.`);
    return;
  }
  if (resultado.ok && resultado.via === 'navegador' && !resultado.html) {
    // No había nada que imprimir. Callarse es correcto: avisar de una
    // impresión vacía solo confunde.
    return;
  }
  if (!resultado.ok && resultado.aviso) toast.warning(resultado.aviso, { duration: 8000 });
  if (resultado.html) abrirParaImprimir(resultado.html, { titulo: queEs });
}
